var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetadataEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M39 16v7h-6v-7h-2v7h-6v-7h-2v7h-7v2h7v6h-7v2h7v6h-7v2h25V16Zm0 9v6h-6v-6Zm-14 0h6v6h-6Zm0 8h6v6h-6Zm8 6v-6h6v6Z",
    style: {
      fill: "#90caf9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 8H8v32h8V16h24Z",
    style: {
      fill: "#00bcd4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 7v34h10V17h24V7Zm2 16v-6h6v6Zm6 2v6H9v-6Zm2-16h6v6h-6Zm8 0h6v6h-6ZM15 9v6H9V9ZM9 39v-6h6v6Zm30-24h-6V9h6Z",
    style: {
      fill: "#0097a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.186 46.78c0 5.523-4.476 10-10 10-5.523 0-10-4.477-10-10 0-5.524 4.477-10 10-10 5.524 0 10 4.476 10 10",
    style: {
      fill: "#43a047"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e57373",
    d: "m45.745 23.114-2.483-2.483a.968.968 0 0 0-1.37 0l-1.167 1.17 3.851 3.852 1.17-1.168a.971.971 0 0 0 0-1.37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M42.65 27.578 25.332 44.896l-3.853-3.853 17.317-17.318Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#b0bec5",
    d: "m38.797 23.729 1.925-1.928 3.856 3.85-1.926 1.929z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "m21.479 41.044-1.296 5.15 5.15-1.297Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#37474f",
    d: "m20.84 43.589-.657 2.605 2.603-.658Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetadataEdit);
export default __webpack_public_path__ + "static/media/metadataEdit.0d93911020d31af09d573128725e5903.svg";
export { ForwardRef as ReactComponent };